export const getTimeStr = (str) => {
  if (str) {
    var oDate = new Date(str * 1000)
    var Y = oDate.getFullYear()
    let M = oDate.getMonth()+1
    let D = oDate.getDate()
    return Y +'-'+ M +'-'+D+' '+oDate.getHours()+':'+oDate.getMinutes();
  }else {
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js